<template>
    <div class="card border-0 border-light shadow question-radio">
        <div class="card-header">
            <h5 class="card-title text-center mb-0" v-html="question.text"></h5>
        </div>
        <ul v-if="question.variants" class="list-group list-group-flush">
            <li class="list-group-item" v-for="(variant, vIndex) in question.variants">
                <div class="custom-control custom-radio custom-control-inline w-100">
                    <input type="radio" class="custom-control-input"
                           :value="variant.id"
                           v-model="valueLocal"
                           :name="'question' + question.id"
                           :id="'variant' + variant.id">
                    <label class="custom-control-label w-100" :for="'variant' + variant.id">
<!--                        {{String.fromCharCode(65 + vIndex)}}.-->
                        {{variant.text}}
                    </label>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                stepsCount: 2,
                currentStep: 1
            }
        },

        props: {
            question: Object,
            index: Number,
            value: ''
        },

        computed: {
            valueLocal: {
                get: function() {
                    return this.value
                },
                set: function(value) {
                    this.$emit('input', value)
                }
            }
        },
    }
</script>
